import { useMemo } from "react";
import { Provider } from "react-redux";
import PhoneSystemPurchase from "./PhoneSystemPurchase";

const PhoneSystemPurchaseApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <PhoneSystemPurchase />
    </Provider>
  );
};

export default PhoneSystemPurchaseApp;
